import "./nav.css"
import {useEffect, useState} from "react";
import {GiHamburgerMenu} from "react-icons/gi";
import Menu from "./Menu";
import Icon from "../../../../components/Icon/Icon";
import {useSession} from "../../../../redux/Reducers/AuthReducer";
import {Link, NavLink} from "react-router-dom";
import ProfileBlock from "./Profile";
import {useDrawer} from "../../../../redux/Reducers/DrawerReducer";




export default function HomeHeader({enabledFixHeaderFix, ...props}) {

    const [menuHidden, setMenuHidden] = useState(true)
    const [isFixed, setIsFixed] = useState(false);
    const {authActions,session} = useSession()
    const {actions} = useDrawer();


    function handleScroll() {
        if (enabledFixHeaderFix === false) return;
        if (window.scrollY > 50) { // Adjust the scroll threshold as needed
            setIsFixed(true)
        } else {
            setIsFixed(false)
        }
    }

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        }

    }, [])


    return (<div className={`${isFixed || enabledFixHeaderFix === false ? "fixed bg-white top-0 z-50 up-to-down-animation " : ""}     w-full nav-component-position `}>
        <div className={"flex justify-center items-center shadow-sm dark:shadow-none   "}>
            <div className={"fixed    dark:bg-darkBgSecondary   nav-common  "}>


            </div>
            <div
                className={" rounded-b-md lg:rounded-b-lg text-gray-900 dark:text-white font-medium  flex flex-col lg:gap-4 lg:flex-row   z-[80] nav-common "}
            >

                <div className={"flex items-center  flex-row"}>

                    {
                      authActions.isUserAuthenticated() ? <GiHamburgerMenu onClick={actions.toggleDrawer}
                                      className={"text-2xl cursor-pointer text-brand-900 "}/>
                          :
                          <GiHamburgerMenu onClick={() => setMenuHidden(!menuHidden)}
                                           className={"text-2xl text-brand-900 lg:hidden"}/>
                    }
                    <Link
                        to={"/"}
                        className={" flex-1 text-xl self-start  lg:text-2xl flex  cursor-pointer items-center flex-row gap-2"}>
                        <img src={"/images/logo.svg"} className={"w-auto ml-2 h-8"} alt={"logo"}/>

                    </Link>


                    {

                        authActions.isUserAuthenticated() ||<div className={"flex lg:hidden gap-8 justify-center items-center"}>
                            <NavLink to={"/auth/login"} className={"flex gap-2 cursor-pointer text-sm justify-center items-center"}>
                                <p>Sign In</p>
                                <Icon src={"/icons/go.svg"} className={"w-4 h-4"}/>
                            </NavLink>

                            <NavLink to={"/auth/sign-up"} className={"rounded-md cursor-pointer text-white text-sm px-2 py-2 bg-tertiary-900"}>
                                <p>Sign Up</p>

                            </NavLink>

                        </div>
                    }

                    {
                        authActions.isUserAuthenticated() && <ProfileBlock  className={"flex lg:hidden"}/>
                    }
                </div>

                <Menu menuHidden={menuHidden} className={""} setMenuHidden={setMenuHidden}/>


                {

                    authActions.isUserAuthenticated() ||<div className={"hidden lg:flex gap-8 justify-center items-center"}>
                        <NavLink to={"/auth/login"} className={"flex gap-2 cursor-pointer text-sm justify-center items-center"}>
                            <p>Sign In</p>
                            <Icon src={"/icons/go.svg"} className={"w-4 h-4"}/>
                        </NavLink>

                        <NavLink to={"/auth/sign-up"} className={"rounded-md cursor-pointer text-white text-sm px-2 py-2 bg-tertiary-900"}>
                            <p>Sign Up</p>

                        </NavLink>

                    </div>
                }

                {
                    authActions.isUserAuthenticated() && <ProfileBlock  className={"hidden lg:flex"}/>
                }



            </div>

        </div>
    </div>)
}
